import { render, staticRenderFns } from "./EmailAuthGoDaddyDomainCard.vue?vue&type=template&id=dceee294&scoped=true"
import script from "./EmailAuthGoDaddyDomainCard.vue?vue&type=script&lang=js"
export * from "./EmailAuthGoDaddyDomainCard.vue?vue&type=script&lang=js"
import style0 from "./EmailAuthGoDaddyDomainCard.vue?vue&type=style&index=0&id=dceee294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dceee294",
  null
  
)

export default component.exports